import React from "react";
import { Link, useLocation } from "react-router-dom";

import "./thankyouPage_contact.css";

import Logo from "../assets/composiq-mark-128.png";

export default function ThankYouContactPage(){
  const location = useLocation();
  const firstName = location.state?.firstName;

  return (
    <div className="App thankyou-page">
      <header className="dbx-header" role="banner">
        <div className="dbx-header-inner">
          <Link to="/" className="dbx-brand" aria-label="Zerivo home">
            <img className="dbx-brand-mark" src={Logo} alt="" />
            <div className="dbx-brand-text-group">
              <span className="dbx-brand-text">Zerivo</span>
              <span className="dbx-brand-subtitle">Private AI</span>
            </div>
          </Link>

          <nav className="dbx-header-nav" aria-label="Main navigation">
            <Link to="/our-team">Our Team</Link>
            <Link to="/contact">Contact</Link>
          </nav>
        </div>
      </header>

      <main className="thankyou-wrapper">
        <section className="thankyou-card" aria-labelledby="thankyou-title">
          <div className="thankyou-kicker">Message received</div>
          <h1 id="thankyou-title" className="thankyou-title">
            {firstName ? `Thanks, ${firstName}.` : "Thanks for reaching out."}
          </h1>
          <p className="thankyou-intro">
            We received your request and will review it with the right context: your environment, review process, and early access fit.
          </p>

          <div className="thankyou-next" aria-label="What happens next">
            <div className="thankyou-next-title">What happens next</div>
            <ul>
              <li>We review your message and route it to the right person.</li>
              <li>We follow up within one business day with practical next steps.</li>
              <li>If needed, we will ask for more context before discussing scope or timelines.</li>
            </ul>
          </div>

          <div className="thankyou-actions">
            <Link to="/" className="dbx-btn dbx-btn-primary">Return home</Link>
            <Link to="/contact" className="dbx-btn dbx-btn-ghost">Send another note</Link>
          </div>
        </section>
      </main>
    </div>
  );
}
